import React from "react";
import { Link } from "react-router-dom";
import { useAuthState } from '../Context';

function Navbar(props){
    const userDetails = useAuthState()
    console.log(userDetails)
    if (Boolean(userDetails.token)) {
        return (<div id={"navcontainer"}>
            <nav className="navbar navbar-expand navbar-dark bg-dark">
                <a href={"https://www.aerialok.com/" } className="navbar-brand">
                    AerialOK
                </a>
                <div className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <Link to={"/3DViewer"} className="nav-link">
                            3D Viewer
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/Activate"} className="nav-link">
                            Activate
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/Logout"} className="nav-link">
                            Logout
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/Upload"} className="nav-link">
                            Upload
                        </Link>
                    </li>
                </div>
            </nav>
        </div>
        )
    } else {
        return (<div>
            <nav className="navbar navbar-expand navbar-dark bg-dark">
                <a href={"https://www.aerialok.com/" } className="navbar-brand">
                    AerialOK
                </a>
                <div className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <Link to={"/3DViewer"} className="nav-link">
                            3D Viewer
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/Register"} className="nav-link">
                            Register
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/Login"} className="nav-link">
                            Login
                        </Link>
                    </li>
                </div>
            </nav>
        </div>)
    }


}

export default Navbar
